import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/AuthService';
import { RestService } from 'src/app/services/RestService';
import { parseJwt } from 'src/app/utilities/all.helpers';


@UntilDestroy()
@Component({
    selector: 'change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false,
})
export class ChangePasswordComponent  {

    @Input() password: string;
    public passwordChanged = false;
    public isPasswordVisible: boolean = false;
    public isValidated = false;
    public isAtLeastMedium!: boolean;
    public token: string;
    public isPasswordValid: boolean = false;
    private passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[?!\/,;]).{8,}$/;


    constructor(
        @Inject(RestService) private restService: RestService,
        private router: Router,
        @Inject(AuthService) private authService: AuthService,
        private route: ActivatedRoute,
        private notification: ToastrService,
    ) {

        inject(BreakpointObserver)
        .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
        .pipe()
        .subscribe((result) => {
            const matches = result.matches;
            this.isAtLeastMedium = matches;
        });
        
    }

    async ngOnInit(): Promise<void> {
            
    
            this.route.params.subscribe(async params => {
                const token = params['token'];
                const payload: any = parseJwt(token);

                const expirationDate = new Date(payload.exp * 1000);
                console.log('Expiration:', expirationDate);
                console.log('Payload:', payload);

                const now = new Date();

                try {
                    if (expirationDate < now) {
                        this.router.navigate(['/']);
                        this.notification.error(
                            "Le lien a expiré. Veuillez recommencer la procédure."
                        );
                        return;
                    }

                    // Continuer avec l'inscription ou autre logique
                } catch (error) {
                    console.error('Error during signup:', error);
                }
            });

    
        }

    async validate() {

        this.route.params.subscribe(async params => {
            const id = params['id'];
            const token = params['token'];
            await this.restService.changePassword(token, id , this.password);
            this.passwordChanged = true;
        });

    }

    public togglePasswordVisibility(): void {
        this.isPasswordVisible = !this.isPasswordVisible;
    }

    
    validatePassword(): void {
        this.isPasswordValid = this.passwordRegex.test(this.password);
    }

    
}
